<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form"
            size="mini"
        >
            <el-form-item>
                <el-form-item label="广告组名称：" class="query-form-item">
                    <el-input
                        v-model="query.ad_portfolio_name"
                        placeholder="请输入广告组名称"
                        style="width: 200px;"
                        @keyup.enter.native="getNewList"
                    ></el-input>
                </el-form-item>
                <!-- <el-form-item label="" class="query-form-item">
                    <el-input v-model="query.state" placeholder="请输入国家" style="width: 200px;"></el-input>
                </el-form-item> -->
                <el-form-item label="国家：" class="query-form-item">
                    <el-select
                        v-model="query.state"
                        ref="carrerSelect"
                        style="width: 120px;"
                        size="mini"
                        filterable
                        clearable
                        @change="getNewList"
                    >
                        <el-option
                            v-for="item in us_arr"
                            :key="item.us"
                            :label="item.title"
                            :value="item.title"
                            :disabled="item.disabled"
                        >
                            <div class="keywords_arr_div">
                                <icon-svg
                                    :icon-class="item.us"
                                    style="font-size: 24px;margin-right:5px;"
                                ></icon-svg>
                                <span
                                    style="font-weight: 700; font-size: 14px;margin-left: 10px;"
                                    >{{ item.title }}</span
                                >
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                        icon="el-icon-refresh"
                        @click="onReset"
                    ></el-button>
                    <el-button
                        icon="el-icon-search"
                        type="primary"
                        @click="onSubmit"
                        >查询</el-button
                    >
                    <el-button type="success" icon="el-icon-plus" @click="add"
                        >上传文件</el-button
                    >
                    <el-button type="success" @click="showUploadFileList">上传文件列表</el-button>
                </el-form-item>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="newList"
            size="mini"
            ref="multipleTable1"
            class="table_content"
            :row-key="getRowKeys1"
            :expand-row-keys="expands"
            border
            style="width: 100%;"
        >
            <el-table-column
                label="广告组合名称"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.ad_portfolio_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="国家" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>
            <el-table-column label="店铺名称" width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shop_name }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="最早日期"
                width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.early_date }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="最晚日期"
                width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.late_date }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="success"
                            size="mini"
                            @click="openOuterVisible(scope.row)"
                        >导出数据</el-button
                        >
                        <el-button
                            style="margin: 5px 0 5px 10px"
                            type="danger"
                            size="mini"
                            @click="openOuterVisibleDelete(scope.row)"
                        >删除</el-button
                        >
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>

        <el-dialog width="600px" title="导出数据" :visible.sync="outerVisible" :show-close="false">
            <Export :data="exportData" @closeExport="closeExport"></Export>
        </el-dialog>
        <el-dialog width="600px" title="确定要删除这条记录吗" :visible.sync="outerVisibleDelete">
            <ExportDelete
                v-if="outerVisibleDelete"
                :data="exportData"
                @closeExport="closeExportDelete"
            ></ExportDelete>
        </el-dialog>

        <add
            :us_arr="us_arr"
            :visible="ctrl.addDialogVisible"
            :title="'添加广告分析数据'"
            @close-callback="closeCllback"
        ></add>
        <upload-file-list :visible="this.uploadFileListVisible" title="上传文件列表" @close-callback="closeCllback"></upload-file-list>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import { binary_download } from "@/utils/method";
import Add from "./add";
import Inline from "./inline";
import Export from "./export";
import ExportDelete from "./exportDelete";
import UploadFileList from './uploadFileList'
export default {
    components: {UploadFileList, Add, Inline, Export, ExportDelete },
    data() {
        return {
            outerVisible: false,
            outerVisibleDelete: false,
            uploadFileListVisible: false,
            exportData: {},
            ctrl: {
                addDialogVisible: false,
                uploadDialogVisible: false
            },
            expands: [],
            record_id: 0,
            formData: {},
            us_arr: [
                {
                    us: "US",
                    title: "美国"
                },
                {
                    us: "UK",
                    title: "英国"
                },
                {
                    us: "DE",
                    title: "德国"
                }
            ],
            query: {
                page: 1,
                shop_name: "",
                ad_portfolio_name: "",
                state: "",
                limit: 20
            },
            list: [],
            newList: [],
            disabled: false,
            loading: false,
        };
    },
    created() {
        this.getData();
    },
    methods: {
        openOuterVisible(row) {
            this.outerVisible = true;
            this.exportData = row;
        },
        closeExport() {
            this.outerVisible = false;
        },
        openOuterVisibleDelete(row) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(()=>{
                api.sp_ad_delete({
                    ad_portfolio_name: row.ad_portfolio_name,
                    shop_name: row.shop_name,
                    state: row.state,
                }).then(() => {
                    this.$message({message: "删除成功", type: "success"});
                });
            }).catch(() => {});

            this.exportData = row;
        },
        closeExportDelete() {
            this.outerVisibleDelete = false;
            this.getNewList();
        },
        // 获取row的key值
        getRowKeys(row) {
            return row.id;
        },
        getRowKeys1(row) {
            return row.index;
        },
        on_add_manual_root(data) {
            this.record_id = data.id;
            api.get_ad_min_name_list({
                record_id: data.admin_id
            })
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        let arr = [];
                        let data = res.data;
                        for (let i = 0; i < data.length; i++) {
                            arr.push({
                                ad_min_name: data[i].ad_min_name,
                                suggest_bidding: data[i].suggest_bidding,
                                target_acos: data[i].target_acos,
                                manual_root: data[i].manual_root.join("\n")
                            });
                        }
                        // console.log(arr);
                        this.$refs.addManual.onData(arr);
                        this.ctrl.AddManualVisible = true;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getNewList() {
            this.loading = true;
            api.sp_ad_list(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.newList = res.data.list;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getData();
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                shop_name: "",
                state: "",
                limit: 20
            };
            this.date = [];
            this.getData();
        },
        //添加文件夹
        add() {
            this.ctrl.addDialogVisible = true;
        },
        showUploadFileList(){
            this.uploadFileListVisible = true
        },
        //删除
        delete_data(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.search_word_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getData();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        //删除
        delete_new_data(data) {
            this.$confirm(`确定要删除这条记录吗?`, {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    api.search_word_delete({
                        id: data.id
                    })
                        .then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.getData();
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(res => {
                            this.$message({
                                type: "error",
                                message: res.message
                            });
                        });
                })
                .catch(() => {});
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getData();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getData();
        },
        // //重置
        // onReset() {
        //     this.query.page = 1;
        //     this.query.limit = 20;
        //     this.getList();
        // },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.addDialogVisible = false;
            this.uploadFileListVisible = false;
            if (isshow) return;
            this.getData();
        },
        handleClick() {
            this.getData();
        },
        getData() {
            this.getNewList();
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}

/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    cursor: pointer;
    // background-color: rgb(221, 233, 255) !important;
    background-color: #fff !important;
}

/deep/ .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell[class*="cell"] {
    padding: 0 !important;
}

.pen:hover {
    cursor: pointer;
    text-decoration: underline;
}

.table_content {
    height: calc(100vh - 190px);
    overflow: auto;
    border: 1px solid #ebeef5;
}

/deep/ .el-table::before {
    display: none;
}
</style>
